import { render, staticRenderFns } from "./CollaborationList.vue?vue&type=template&id=65ba4372&scoped=true"
import script from "./CollaborationList.vue?vue&type=script&lang=js"
export * from "./CollaborationList.vue?vue&type=script&lang=js"
import style0 from "./CollaborationList.vue?vue&type=style&index=0&id=65ba4372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba4372",
  null
  
)

export default component.exports